import LcRequest from '@/api/request/request'

import localCache from '@/utils/cache'
import { clearSessionCache } from '@/utils/auth-session'

/**
 * 封装-全局请求实例
 *
 * baseURL 来自环境变量 VUE_APP_API_BASE_URL，默认 /api。
 * - 开发：请求 /api → vue.config.js 代理到本机后端
 * - 生产：请求 /api → Nginx 同源转发到 gatehouse-web（无需在打包时写死服务器地址）
 */
const BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api'
const TIMEOUT = 10000

const handleUnauthorized = () => {
  clearSessionCache()

  // 后台 token 失效时跳登录页（整页刷新，重置 vuex / 动态路由）
  if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

const lcRequest = new LcRequest({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  interceptors: {
    requestInterceptor: (config) => {
      // 携带token的拦截
      const token = localCache.getCache('token')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    requestInterceptorCatch: (err) => {
      return err
    },
    responseInterceptor: (res) => {
      if (String(res?.data?.errorCode) === '401') {
        handleUnauthorized()
      }
      return res
    },
    responseInterceptorCatch: (err) => {
      if (err?.response?.status === 401 || String(err?.responseData?.errorCode) === '401') {
        handleUnauthorized()
      }
      return Promise.reject(err)
    }
  }
})

export default lcRequest
